export default __webpack_public_path__ + "static/media/Matching_score.97a52f65.svg";